module.exports = __webpack_public_path__ + "media/images/products/g1c/g1c-1-1000x1000-9be5395a9eeb2f93b08bc1746aed6745.png";